import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { ContractorSearchInterfacePropsType } from '../..';
import { DETERIORATION_LIST } from './consts/deteriorationList';

const { tablet, mobile } = mediaQueries();

const KEY_NAME = 'SearchByDeterioration';
const PARAM_NAME = 'deterioration';

export type SearchByReviewPropsType = Merge<ContractorSearchInterfacePropsType & {
  onApplyHandler: () => void;
}>;

export const SearchByDeterioration = (props: SearchByReviewPropsType) => {
  const { userAnswers, commonAnswerHandler, onApplyHandler: onApplyHandlerFromProps } = props;
  const onApplyHandler = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const { value } = event.currentTarget;
    commonAnswerHandler(PARAM_NAME, value || '');

    userAnswers.push({
      keyName: 'searchByDeterioration',
      paramName: PARAM_NAME,
      question: 'お家の劣化は',
      answer: value || '',
      value: value || '',
    });

    onApplyHandlerFromProps();
  }, [commonAnswerHandler, onApplyHandlerFromProps, userAnswers]);

  return (
    <div
      css={css`
        ${tablet(() => css`
          max-width: 568px;
          margin-inline: auto;
          padding: 0 1em;
        `)}
      `}
    >
      <div
        css={css`
          margin-bottom: 24px;

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            margin-bottom: ${setAutomaticDesignBasedSize(24, 20)};
          `)}
        `}
      >
        <p
          css={css`
            color: #000;
            font-size: 20px;
            font-weight: bold;

            ${mobile(({ setAutomaticDesignBasedSize }) => css`
              font-size: ${setAutomaticDesignBasedSize(20, 18)};
            `)}
          `}
        >
          劣化状況から探す
        </p>
      </div>
      <div
        css={css`
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0 20px;

          ${tablet(({ setAutomaticDesignBasedSize }) => css`
            font-size: ${setAutomaticDesignBasedSize(16, 14)};
            grid-template-columns: repeat(2, 1fr);
            gap: ${setAutomaticDesignBasedSize(20, 10)};
          `)}

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            font-size: ${setAutomaticDesignBasedSize(16, 14)};
            gap: ${setAutomaticDesignBasedSize(20, 10)};
          `)}
        `}
      >
        {DETERIORATION_LIST.map((deterioration) => {
          const { id, imagePaths, text } = deterioration;
          const { png, png2x, webp, webp2x } = imagePaths;

          return (
            <button
              key={id}
              value={text}
              onClick={onApplyHandler}
              id={`ga_event_${KEY_NAME}_button_${id}`}
              css={css`
                color: #041156;
                font-size: 15px;
                font-weight: bold;
                text-align: center;
                background-color: #fff;
                border-radius: 8px;

                ${mobile(({ setAutomaticDesignBasedSize }) => css`
                  font-size: ${setAutomaticDesignBasedSize(15, 14)};
                `)}

                &:hover {
                  background-color: #fff7c9;
                }
              `}
            >
              <span
                css={css`
                  font-size: 0;
                  display: block;
                  width: 100%;
                `}
              >
                <picture>
                  <source
                    srcSet={`${webp} 1x, ${webp2x} 2x`}
                    type="image/webp"
                  />
                  <img
                    srcSet={`${png} 1x, ${png2x} 2x`}
                    src={png}
                    alt={text}
                  />
                </picture>
              </span>
              <span
                css={css`
                  display: block;
                  padding: 5px 0;
                  border: 1px solid #041156;
                  border-radius: 0 0 8px 8px;
                `}
              >
                {text}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
